<template>
	<div>
		<el-table :data="list" border size="mini">
			<el-table-column prop="number" align="center" :label="$t('virtual.no')" data-name="序号"></el-table-column>
			<el-table-column prop="class_date_time" align="center" :label="$t('virtual.time')" data-nam="时间">
				<template slot-scope="scope"> {{getTime_us(scope.row.class_date_time,'mmddyyyy')}} {{getTime_us(scope.row.start_time,'hh:ii')}} </template>
			</el-table-column>
			<el-table-column prop="status" align="center" :label="$t('virtual.status')" data-name="状态" :formatter="status_f"></el-table-column>
			<el-table-column prop="content" align="center" :label="$t('index.operation')" data-name="操作">
				<template slot-scope="scope">
			        <el-button size="mini" type="primary" @click="attendance(scope.row)" data-name="出勤">{{$t('virtual.attendance')}}</el-button>
			        <el-button size="mini" type="primary" @click="task(scope.row)" data-name="作业">{{$t('virtual.task')}}</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div class="page-pagination">
			<el-pagination align="right" small background :hide-on-single-page="false" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pages.page" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="pages.perpage" layout="total, prev, pager, next, sizes, jumper" :total="pages.count" :pager-count="5"></el-pagination>
		</div>
		<el-dialog :title="$t('virtual.attendance')" width="800px" :close-on-click-modal="false" :append-to-body="true" :visible="rollcallhistory_is" @close="rollcallhistory_is = false">
			<div class="roll_history">
				<div class="roll_history_felx">
					<div class="p1">{{$t('virtual.arrived_num')}}: {{rollcallhistory.yidao_num}}</div>
					<div class="p1">{{$t('virtual.not_arrived_num')}}: {{rollcallhistory.qingjia_num}}</div>
				</div>
				<el-table :data="table_rollcallhistory" style="width: 100%" border>
					<el-table-column align="center" prop="name" label="姓名"></el-table-column>
					<el-table-column align="center" prop="remark" label="备注"></el-table-column>
					<el-table-column align="center" prop="create_time" label="点名时间">
						<template slot-scope="{row}">{{getTime_us(row.create_time,'mmddyyyy')}} {{getTime_us(row.create_time,'ampm')}}</template>
					</el-table-column>
					<el-table-column align="center" prop="status" label="状态">
						<template slot-scope="{row}">
						 	<div v-if="row.status==1">{{$t('student_list.status1')}}</div>
						 	<div v-if="row.status==2">{{$t('student_list.status2')}}</div>
						</template>
					</el-table-column>
				</el-table>
				<!-- <div class="p2">
					<span v-for="(item,index) in rollcallhistory.yidao" :key="index">{{item.name}}</span>
				</div> -->
				<!-- <div class="p2"> -->
					<!-- <div v-for="(item,index) in rollcallhistory.qingjia" :key="index">{{item.name}} ({{item.remark}})</div> -->
				<!-- </div> -->
			</div>
		</el-dialog>
		<el-dialog :title="$t('virtual.task')" width="1200px" :close-on-click-modal="false" :append-to-body="true" :visible="workdetail_is" @close="workdetail_is = false">
			<el-form  size="mini" label-position="top" v-if="workdetail.title">
				<el-col :span="24">
					<el-form-item :label="$t('virtual.task_name')" data-name="标题">
						<div class="font_input">{{workdetail.title}}</div>
					</el-form-item>
				</el-col>
				<el-col :span="24">
					<el-form-item :label="$t('virtual.task_content')" data-name="内容">
						<div class="font_input">{{workdetail.content}}</div>
					</el-form-item>
				</el-col>
				<el-col :span="24">
					<el-form-item :label="$t('virtual.task_file')" data-name="附件">
						<div class="font_input">
							<div class="img_img" v-for="(item,index) in workdetail.filename" :key="index">
								<video v-if="item.type=='video'" :src="item.url" loop="loop" controls="controls" poster="" class="video"></video>
								<img v-else-if="item.type=='image'" :src="item.url" class="video" alt="">
								<iframe v-else-if="item.type=='iframe'" :src="item.url"  frameborder="0" class="video"></iframe>
								<div v-else-if="item.type=='html'" v-html="item.url" class="video"></div>
								<el-input v-else class="shangchuan" :value="item.url">
									<el-button slot="append" data-name="下载" @click="download(item.url)">{{$t('virtual.download')}}</el-button>
								</el-input>
							</div>
						</div>
					</el-form-item>
				</el-col>
			</el-form>
			<el-table :data="childrenlist" border class="w100">
				<el-table-column align="center" prop="name" :label="$t('journal.child_name')" data-name="学生"></el-table-column>
				<el-table-column align="center" prop="user_name" :label="$t('virtual.parent')" data-name="家长"></el-table-column>
				<el-table-column align="center" prop="name" :label="$t('index.operation')" data-name="操作">
					<template slot-scope="scope">
				        <el-button size="mini" type="primary" @click="zuoye(scope.row)" data-name="作业">{{$t('virtual.task')}}</el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-dialog :title="$t('virtual.task')" width="1000px" :close-on-click-modal="false" :append-to-body="true" :visible="work_is" @close="work_is = false">
				<el-form  size="mini" label-position="top">
					<el-row v-for="(items,indexs) in detail" :key="indexs">
						<el-col :span="24">
							<el-form-item :label="$t('virtual.task_name')" data-name="标题">
								<div class="font_input">{{items.work}}</div>
							</el-form-item>
						</el-col>
						<el-col :span="24">
							<el-form-item :label="$t('virtual.task_file')" data-name="附件">
								<div class="font_input">
									<div class="img_img" v-for="(item,index) in items.filename" :key="index">
										<video v-if="item.type=='video'" :src="item.url" loop="loop" controls="controls" poster="" class="video"></video>
										<img v-else-if="item.type=='image'" :src="item.url" class="video" alt="">
										<iframe v-else-if="item.type=='iframe'" :src="item.url"  frameborder="0" class="video"></iframe>
										<div v-else-if="item.type=='html'" v-html="item.url" class="video"></div>
										<el-input v-else class="shangchuan" :value="item.url">
											<el-button slot="append" data-name="下载" @click="download(item.url)">{{$t('virtual.download')}}</el-button>
										</el-input>
									</div>
								</div>
							</el-form-item>
						</el-col>
					</el-row>
				</el-form>
			</el-dialog>
		</el-dialog>
	</div>
</template>
<script>
export default {
	computed: {
		editFormRules() {
			return {
				reply: [{
					required: true,
					message: this.$t('index.pleaseInput') + this.$t('virtual.reply'),
					trigger: 'change'
				}],
			}
		},
	},
	props:{
		type: {
			type: String,
			default:''
		},
		course_id: {
			type: String,
			default:''
		},
		course_type: {
			type: String,
			default:''
		},
	},
	data() {
		return {
			pages: {
				page: 1,
				count: 0,
				perpage: 20,
			},
			list:[],
			this_:this,
			rollcallhistory:{},
			rollcallhistory_is:false,
			workdetail_is:false,
			workdetail:{},
			childrenlist:[],
			work_is:false,
			trip_id:'',
			detail:{},
			table_rollcallhistory:[],
		}
	},
	watch: {
		type(v){
			if (v=='course') {
				this.init();
			}
		},
	},
	computed:{
		today_start_time:function(){
			var nian=this.getTime('','y');
			return Math.round(new Date(nian.split('-')[0],nian.split('-')[1]-1,nian.split('-')[2],'00','00','00').getTime()/1000);
		},
		today_end_time:function(){
			var nian=this.getTime('','y');
			return Math.round(new Date(nian.split('-')[0],nian.split('-')[1]-1,nian.split('-')[2],'23','59','59').getTime()/1000);
		},
	},
	// 初始事件
	mounted: function () {
	},
	// 事件
	methods: {
		init(){
			var this_ = this;
			var url = "ClassesBoardList";
			var datas = {
				course_id:this_.course_id,
				type: this_.course_type,
				page: this_.pages.page,
				num: this_.pages.perpage,
				today_start_time:this_.today_start_time,
				today_end_time:this_.today_end_time,
			};
			this_.$post(url, datas).then((res) => {
				this_.list = res.list;
				this_.pages.count = res.sum;
			})
		},
		// 上课状态
		status_f(w,s,d){
			var status_cn = {'1':'未开课','2':'进行中','3':'已结束','9':'未点名'};
			var status_en = {'1':'UpComing','2':'OnGoing','3':'Finished','9':'UnFinished'};
			var zhi= this.lang=='cn'?status_cn[d]:status_en[d];
			return zhi;
		},
		// 出勤
		attendance(data){
			var this_ = this;
			var url = "adminRollCallHistory";
			var datas = {
				trip_id:data.id
			};
			this_.$post(url, datas).then((res) => {
				this_.rollcallhistory=res;
				this_.table_rollcallhistory = [...res.yidao,...res.qingjia];
				this_.rollcallhistory_is=true;
			})
		},
		task(data){
			var this_ = this;
			var url = "adminTeacherWorkDetail";
			this_.trip_id=data.id;
			var datas = {
				trip_id:data.id
			};
			this_.$post(url, datas).then((res) => {
				var workdetail=res;
				if (res.filename) {
					workdetail['filename']=JSON.parse(res.filename);
				}
				this_.workdetail=workdetail;
				this_.virtualChildrenList();
			})
		},
		// 学生列表
		virtualChildrenList(data){
			var this_ = this;
			var url = "virtualChildrenList";
			var datas = {
				course_id:this_.course_id,
				course_type: this_.course_type,
				page: this_.pages.page,
				num: this_.pages.perpage,
			};
			this_.$post(url, datas).then((res) => {
				this_.childrenlist=res;
				this_.workdetail_is=true;
			})
		},
		zuoye(data){
			var this_ = this;
			var url = "adminChildWorkList";
			var datas = {
				children_id:data.child_id,
				trip_id: this_.trip_id,
			};
			this_.$post(url, datas).then((res) => {
				var list=res.list;
				list.forEach(function(e,i) {
					if (e.filename) {
						e['filename']=JSON.parse(e.filename);
					}
				});
				// var detail=res.children_work;
				// if (res.filename) {
				// 	detail['filename']=JSON.parse(res.filename);
				// }
				this_.detail=list;
				this_.work_is=true;
			})

		},
		// 分页每页显示几条
		handleSizeChange(val) {
			var pages = this.pages;
			pages['perpage'] = val;
			this.pages = pages;
			this.init();
		},
		// 切换分页
		handleCurrentChange(val) {
			var pages = this.pages;
			pages['page'] = val;
			this.pages = pages;
			this.init();
		}
	},
	// 过滤器
	filters: {

	}
}
</script>
<style scoped>
.font_input{
	line-height: 1.4;
}
.page-pagination{
	padding: 20px 10px 0;
}
.roll_history .p1{
	font-size: 20px;
	color: #000000;
	font-weight: bold;
	margin-bottom: 10px;
}
.roll_history .p2{
	margin-bottom: 40px;
	font-size: 20px;
	color: #000000;
}
.roll_history .p2 span{
	margin-right: 30px;
	margin-bottom: 20px;
}
.roll_history_felx{
	display: flex;
    justify-content: space-between;
}
.img_img{
	float: left;
	margin-right: 10px;
	width: 232px;
	height: 230px;
	margin-bottom: 10px;
}
.img_img:nth-child(4n){
	margin-right: 0;
}
.img_img .video{
	width: 100%;
	height: 100%;
	object-fit: contain;
}
</style>



// WEBPACK FOOTER //
// src/components/course.vue